// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DumpsterRentalHighlandUtRouteImport } from './routes/dumpster-rental-highland-ut'
import { Route as FallCleanupHighlandUtRouteImport } from './routes/fall-cleanup-highland-ut'
import { Route as JunkRemovalHighlandUtRouteImport } from './routes/junk-removal-highland-ut'
import { Route as LandClearingHighlandUtRouteImport } from './routes/land-clearing-highland-ut'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as SnowRemovalHighlandUtRouteImport } from './routes/snow-removal-highland-ut'
import { Route as SpringCleanupHighlandUtRouteImport } from './routes/spring-cleanup-highland-ut'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as WeedControlHighlandUtRouteImport } from './routes/weed-control-highland-ut'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ServiceAreasIndexRouteImport } from './routes/service-areas/index'
import { Route as ServiceAreasSlugRouteImport } from './routes/service-areas/$slug'
import { Route as ServicesSlugRouteImport } from './routes/services/$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DumpsterRentalHighlandUtRoute = DumpsterRentalHighlandUtRouteImport.update({
            id: '/dumpster-rental-highland-ut',path: '/dumpster-rental-highland-ut',getParentRoute: () => rootRouteImport
          })
const FallCleanupHighlandUtRoute = FallCleanupHighlandUtRouteImport.update({
            id: '/fall-cleanup-highland-ut',path: '/fall-cleanup-highland-ut',getParentRoute: () => rootRouteImport
          })
const JunkRemovalHighlandUtRoute = JunkRemovalHighlandUtRouteImport.update({
            id: '/junk-removal-highland-ut',path: '/junk-removal-highland-ut',getParentRoute: () => rootRouteImport
          })
const LandClearingHighlandUtRoute = LandClearingHighlandUtRouteImport.update({
            id: '/land-clearing-highland-ut',path: '/land-clearing-highland-ut',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const SnowRemovalHighlandUtRoute = SnowRemovalHighlandUtRouteImport.update({
            id: '/snow-removal-highland-ut',path: '/snow-removal-highland-ut',getParentRoute: () => rootRouteImport
          })
const SpringCleanupHighlandUtRoute = SpringCleanupHighlandUtRouteImport.update({
            id: '/spring-cleanup-highland-ut',path: '/spring-cleanup-highland-ut',getParentRoute: () => rootRouteImport
          })
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
            id: '/terms-and-conditions',path: '/terms-and-conditions',getParentRoute: () => rootRouteImport
          })
const WeedControlHighlandUtRoute = WeedControlHighlandUtRouteImport.update({
            id: '/weed-control-highland-ut',path: '/weed-control-highland-ut',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ServiceAreasIndexRoute = ServiceAreasIndexRouteImport.update({
            id: '/service-areas/',path: '/service-areas/',getParentRoute: () => rootRouteImport
          })
const ServiceAreasSlugRoute = ServiceAreasSlugRouteImport.update({
            id: '/service-areas/$slug',path: '/service-areas/$slug',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/services/$slug',path: '/services/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,ContactRoute: ContactRoute,DumpsterRentalHighlandUtRoute: DumpsterRentalHighlandUtRoute,FallCleanupHighlandUtRoute: FallCleanupHighlandUtRoute,JunkRemovalHighlandUtRoute: JunkRemovalHighlandUtRoute,LandClearingHighlandUtRoute: LandClearingHighlandUtRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,SnowRemovalHighlandUtRoute: SnowRemovalHighlandUtRoute,SpringCleanupHighlandUtRoute: SpringCleanupHighlandUtRoute,TermsAndConditionsRoute: TermsAndConditionsRoute,WeedControlHighlandUtRoute: WeedControlHighlandUtRoute,BlogSlugRoute: BlogSlugRoute,ServiceAreasSlugRoute: ServiceAreasSlugRoute,ServicesSlugRoute: ServicesSlugRoute,BlogIndexRoute: BlogIndexRoute,ServiceAreasIndexRoute: ServiceAreasIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)